import TYPES from './types';
import COMMON_TYPES from '../../../actions/types';
import { showNotificationLayer } from '../../../actions/notification';
import { remove as d } from '../../../api/common';

const loadingPostDelete = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const remove = params => {
  return dispatch => {
    dispatch(loadingPostDelete());

    d(params.formParams.id, 'secretaria.php')
      .then(() => {
        dispatch(loadingPostDelete());
        dispatch(toggleFormDeleteLayer());

        dispatch({
          type: TYPES.deleteList,
          payload: params.formParams,
        });

        dispatch(
          showNotificationLayer(
            `A secretaria ${params.formParams.name} foi removida!`
          )
        );
      })
      .catch(responseFail => {
        dispatch(loadingPostDelete());

        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response,
        });
      })
  }
}

export const toggleFormDeleteLayer = params => {
  if(params && params.id) {
    return [
      { type: COMMON_TYPES.toggleLayer, payload: 'delete' },
      { type: COMMON_TYPES.formInitializeValues, payload: params },
    ];
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.formClearValues },
  ];
};
